class Logger {
  private static colors: { [key: string]: string } = {
    ERROR: '\x1b[31m', // Red
    INFO: '\x1b[32m', // Green
    DEBUG: '\x1b[34m', // Blue
    RESET: '\x1b[0m', // Reset
  }

  // create logger function based on levels and colors
  private static buildLogger = (level: string) => {
    return (message: string) => {
      const color = this.colors[level] || this.colors.RESET
      console.log(`${color}[${level}] ${message}${this.colors.RESET}`)
    }
  }

  // Create logger function
  public static error = this.buildLogger('ERROR')
  public static info = this.buildLogger('INFO')
  public static debug = this.buildLogger('DEBUG')
}

export const logger = Logger

// Create viewport check so that based on screen size I'll dedcide if code needs to run or not . create class
export class Viewport {
  static isPhone(): boolean {
    return window.innerWidth <= 478
  }

  static isPhoneLandscape(): boolean {
    return window.innerWidth > 478 && window.innerWidth <= 700
  }

  static isTablet(): boolean {
    return window.innerWidth > 700 && window.innerWidth <= 991
  }

  static isDesktop(): boolean {
    return window.innerWidth > 991
  }

  /**
   * Phone = 0 - 478 ;
   * Phone Landscape = 479 - 700 ;
   * Tablet = 701 - 991 ;
   * Desktop = 992 - Infinity ;
   * @returns {number} width of the viewport
   */
  static width(): number {
    return window.innerWidth
  }

  static height(): number {
    return window.innerHeight
  }
}
